import sendToServer from './send-to-server';
import trackEvent from './track-event';

const Dashboard = {
  init() {
    if ($('.dashboard').length !== 1) return;

    $('.launcher').click(this.handleLauncherClick);
    $('.close-button').click(this.handleCloseButtonClick);
    $('#feedback-body').keyup(this.handleFeedbackTyping);
    $('#feedback-submit-button').click(this.handleFeedbackSubmitClick.bind(this));
    $('.onboarding-screen .next').click(this.handleOnboardButtonClick.bind(this));
    $('.quick-links-toggle').click(this.handleQuickLinksToggleClick);
    $('.cta-button').click(this.handleCtaButtonClick);
    $('.share-expander').click(this.handleShareExpanderClick);
    $('.quickstart-section').click(this.handleQuickstartSectionClick);
    $('.quickstart-preparation-button').click(this.handlePreparationButtonClick);
    $('.skill-survey-button').click(this.handleSkillSurveyButtonClick);
    if ($('.feedback-highlighter').length > 0) this.markFeedbackHighlighted();
    $('.feedback-highlighter').click(this.handleFeedbackHighlighterCloserClick);
    $('.skill-option input[type=checkbox]').change(this.handleCheckSkillOption.bind(this));
    $('.upcoming-badge-notification-section').click(this.handleBadgeToggleClick);
  },

  handleLauncherClick(event) {
    let $chosenBox = $(event.target).closest('.launcher');
    $('#' + $chosenBox.data('launches')).fadeIn();
  },

  handleCloseButtonClick() {
    $('.popup').fadeOut();
  },

  handleFeedbackTyping() {
    if ($('#feedback-body').val().length > 0) {
      $('#feedback-submit-button').prop('disabled', false);
    } else {
      $('#feedback-submit-button').prop('disabled', true);
    }
  },

  handleFeedbackSubmitClick() {
    sendToServer('/api/v2/messages',
                 {body: $('#feedback-body').val()},
                 this.brieflyShowFeedbackSuccessMessage);
    $('.popup').fadeOut();
    $('#feedback-body').val('');
  },

  brieflyShowFeedbackSuccessMessage() {
    window.setTimeout(()=>{ $('.feedback-success-message').fadeOut() }, 3000)
    $('.feedback-success-message').fadeIn();
  },

  handleOnboardButtonClick(event) {
    let $currentScreen = $(event.target).closest('.onboarding-screen');
    if ($currentScreen.attr('id') == 'first-onboarding-screen') {
      if ($('#second-onboarding-screen').length > 0) {
        $('#second-onboarding-screen').fadeIn(300, () => { $currentScreen.fadeOut() });
        trackEvent('Onboarding', 'progressed to second screen');
      } else {
        // Assume that if there's no second screen there's no third either
        this.progressPastThirdOnboardingScreen($currentScreen);
      }

    } else if ($currentScreen.attr('id') == 'second-onboarding-screen') {
      $('#third-onboarding-screen').fadeIn(300, () => { $currentScreen.fadeOut() });
      trackEvent('Onboarding', 'progressed to third screen');
    } else if ($currentScreen.attr('id') == 'third-onboarding-screen') {
      this.progressPastThirdOnboardingScreen($currentScreen);
    }
  },

  progressPastThirdOnboardingScreen($currentScreen) {
    if ($('#three-point-fifth-onboarding-screen').length > 0) {
      $('#three-point-fifth-onboarding-screen').fadeIn(300, () => { $currentScreen.fadeOut() });
    } else if ($('#fourth-onboarding-screen').length > 0) {
      $('#fourth-onboarding-screen').fadeIn(300, () => { $currentScreen.fadeOut() });
      trackEvent('Onboarding', 'progressed to fourth screen');
    } else {
      $currentScreen.fadeOut();
      trackEvent('Onboarding', 'completed');
    }
  },

  handleQuickLinksToggleClick() {
    if ($('.quick-links-toggle .glyphicon-chevron-right').length > 0) {
      $('.quick-links-toggle .glyphicon-chevron-right')
        .removeClass('glyphicon-chevron-right')
        .addClass('glyphicon-chevron-down');
    } else {
      $('.quick-links-toggle .glyphicon-chevron-down')
        .removeClass('glyphicon-chevron-down')
        .addClass('glyphicon-chevron-right');
    }
    $('.quick-links').slideToggle();
  },

  handleCtaButtonClick() {
    sendToServer('/api/v2/events/',
                 { event: 'followed_cta' });
  },

  handleShareExpanderClick() {
    $('.share-options').slideDown();
    sendToServer('/api/v2/events/',
                 { event: 'clicked_share' });

  },

  handleQuickstartSectionClick(event) {
    const $section = $(event.target).closest('.quickstart-section');
    if ($section.hasClass('inspiration')) {
      sendToServer('/api/v2/events',
                 { event: 'requested_inspiration' });
    } else if ($section.hasClass('exploration')) {
      sendToServer('/api/v2/events',
                 { event: 'requested_exploration' });
    }
  },

  handlePreparationButtonClick() {
    const careerId = $('.quickstart-preparation-selector option:selected').val();
    sendToServer('/api/v2/events',
                 { event: 'requested_preparation',
                   career_id: careerId });
    window.location = `/app/careers/${careerId}/questions/1`;
  },

  handleSkillSurveyButtonClick() {
    const checkeds = $('#skill-survey input:checked');
    if (checkeds.length !== 3) return;
    const skillIds = checkeds.toArray().map((input) => $(input).val());

    sendToServer('/api/v2/me',
                 { self_reported_strongest_skill_ids: skillIds},
                 null,
                 'PATCH');

    const $screen = $('#three-point-fifth-onboarding-screen');

    if ($('#fourth-onboarding-screen').length > 0) {
      $('#fourth-onboarding-screen').fadeIn(300, () => { $screen.fadeOut() });
      trackEvent('Onboarding', 'progressed to fourth screen');
    } else {
      $screen.fadeOut();
      trackEvent('Onboarding', 'completed');
    }
  },

  markFeedbackHighlighted() {
    sendToServer('/api/v2/me',
                 { feedback_highlighted: true},
                 null,
                 'PATCH');
  },

  handleFeedbackHighlighterCloserClick() {
    $('.feedback-highlighter').hide();
  },

  handleCheckSkillOption() {
    const checkeds = $('#skill-survey input:checked');
    if (checkeds.length === 3) {
      $('.skill-survey-button').prop('disabled', false);
    } else {
      $('.skill-survey-button').prop('disabled', true);
    }
  },

  handleBadgeToggleClick() {
    $('.upcoming-badge-section').slideToggle();
  }
};

$(document).ready(()=> {
  Dashboard.init();
});
